// extracted by mini-css-extract-plugin
module.exports = {"HeartbeatsList":"HeartbeatPage_HeartbeatsList__2XDOU","HeartbeatsTitle":"HeartbeatPage_HeartbeatsTitle__1RQOa"};